var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sidebar-view-control",class:_vm.classes},[_c('BnIcon',{staticClass:"icon",attrs:{"name":_vm.icon,"filled":"","size":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }